import { IApplicationState } from '../../types/redux';

export function getHouseId(state: IApplicationState) {
  return state.floorPlan.houseId;
}
